module.exports = __webpack_public_path__ + "img/teacher.84e9fa7b.jpeg";